// @flow

export const QueryParams = {
  QUERY_PROMOTION_CODE_ID: "einladungscode",
  QUERY_TOP_DEAL_ID: "td",
  QUERY_CHANNEL_ID: "cid",
  QUERY_CLICK_ID: "ci",
  QUERY_EXCEPTION_ID: "e",
  QUERY_PARTNER_ID: "pid",
  QUERY_SHORT_OFFER_REMINDER_ELECTRICITY: "stromwechsel",
  QUERY_SHORT_OFFER_REMINDER_GAS: "gaswechsel",
  QUERY_CATEGORY_ELECTRICITY: "strom",
  QUERY_CATEGORY_GAS: "gas",
};
